export default "__VITE_ASSET__DQKRMsdD__"